<template>
  <b-container fluid class="page home-banner white-bg p-0 page-active">
    <b-row class="no-gutters full-screen m-0">
      <b-col xl="4" lg="3" md="12" sm="12" class="img-col d-none d-lg-block">
        <img :src="image" class="col-lg-12" :alt="alt"
             :style="`opacity: ${opacity}`"/>
        <div class="border-container"/>
        <div class="page-title">
          <slot name="pr-1"/>
        </div>
      </b-col>
      <b-col xl="8" lg="9" md="12" sm="12" class="">
        <div class="page-content">
          <slot name="pl-1"/>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "S104",
  props: {
    image: {default: "https://picsum.photos/500/1700"},
    alt: {default: 'alt'},
    opacity: {default: 1}
  }
}
</script>

<style scoped>

.page-active {
  position: relative;
  z-index: 5;
  top: -60px;
}

.border-container {
  position: absolute;
  top: 10%;
  right: 10%;
  left: 10%;
  bottom: 5%;
  z-index: 2;
  border-bottom: 2px solid white;
  border-right: 2px solid white;
}

.img-col {
  padding: 0;
  margin: 0;
  background-color: var(--light);
}

.img-col img {
  object-fit: contain;
  top: 100px;
  position: sticky
}
</style>